import React from 'react';

function MembersDrawer({
  total,
  members,
  loading,
  onClose,
  currentUsername,
  ownerUsername,
  canLeave,
  onLeave,
}) {
  const title = `Supporters — ${typeof total === 'number' ? total : members.length}`;

  return (
    <aside
      className="community-drawer"
      role="complementary"
      aria-label="Chat participants"
    >
      <header className="community-drawer__header">
        <h2 className="community-drawer__title">{title}</h2>
        <button
          type="button"
          className="community-drawer__close"
          onClick={onClose}
          aria-label="Close participants"
        >
          ×
        </button>
      </header>

      {canLeave && (
        <div className="community-drawer__actions">
          <button
            type="button"
            className="community-drawer__leave"
            onClick={onLeave}
          >
            Leave chat
          </button>
          <p className="community-drawer__leave-hint">
            You can rejoin anytime from @{ownerUsername}'s profile.
          </p>
        </div>
      )}

      {loading ? (
        <div className="community-drawer__loading">Loading…</div>
      ) : members.length === 0 ? (
        <div className="community-drawer__empty">No members yet.</div>
      ) : (
        <ul className="community-drawer__list">
          {members.map((m) => {
            const isYou = currentUsername && m.username === currentUsername;
            const isOwner = ownerUsername && m.username === ownerUsername;
            return (
              <li key={m.userId || m.username} className="community-drawer__item">
                {m.profileImage ? (
                  <img
                    className="community-drawer__avatar"
                    src={m.profileImage}
                    alt=""
                  />
                ) : (
                  <span className="community-drawer__avatar community-drawer__avatar--fallback">
                    {(m.username || '?').charAt(0).toUpperCase()}
                  </span>
                )}
                <span className="community-drawer__name">
                  {m.username}
                  {isOwner && <span className="community-drawer__owner-tag">owner</span>}
                  {isYou && !isOwner && <span className="community-drawer__owner-tag">you</span>}
                </span>
              </li>
            );
          })}
        </ul>
      )}
    </aside>
  );
}

export default MembersDrawer;
